import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-striped border-light align-middle" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_15 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
        _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.id_date')), 1),
        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.payment_date')), 1),
        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.rate')), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deals, (deal) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: deal.id
        }, [
          _createElementVNode("td", null, [
            _createVNode(_component_PayMethodIcon, {
              method: deal.method
            }, null, 8, ["method"])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, [
                _createElementVNode("span", {
                  title: deal.publicId
                }, _toDisplayString(deal.publicId), 9, _hoisted_10),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(_component_copy_button, {
                  value: deal.publicId
                }, null, 8, ["value"])
              ]),
              _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.dateHelper.format(deal.createdAt)), 1)
            ])
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${deal.type}`)), 1),
          _createElementVNode("td", {
            class: _normalizeClass({'text-primary': deal.status === _ctx.DealStatus.TRANSFER_CONFIRMED})
          }, [
            _createTextVNode(_toDisplayString(_ctx.helper.trans(`deal_status.${deal.status}`)) + " ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deal.attachments, (attachment) => {
              return (_openBlock(), _createElementBlock("a", {
                key: attachment.id,
                href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                target: "_blank",
                type: "button",
                class: "me-2 text-warning"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
              ]), 8, _hoisted_12))
            }), 128))
          ], 2),
          _createElementVNode("td", null, _toDisplayString(deal.paymentAt ? _ctx.dateHelper.format(deal.paymentAt) : 'n/a'), 1),
          _createElementVNode("td", null, [
            (deal.requisite)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, [
                    (deal.requisite.startsWith('http'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: deal.requisite,
                          target: "_blank"
                        }, _toDisplayString(_ctx.helper.domain(deal.requisite)), 9, _hoisted_13))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(deal.requisite), 1)
                        ], 64)),
                    _createVNode(_component_copy_button, {
                      value: deal.requisite
                    }, null, 8, ["value"])
                  ]),
                  (deal.holder)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(deal.holder), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
          ]),
          _createElementVNode("td", null, _toDisplayString(deal.takerSum ? _ctx.numberFormatter.formatMoney(deal.takerSum) : 'n/a') + " / " + _toDisplayString(deal.makerSum ? _ctx.numberFormatter.formatMoney(deal.makerSum) : 'n/a'), 1),
          _createElementVNode("td", null, _toDisplayString(deal.rate), 1)
        ]))
      }), 128))
    ])
  ]))
}